/**
 * Client-side module label formatting (aligned with backend moduleDisplayName.js).
 */
export const MODULE_DISPLAY_NAMES = {
  student: "Student Profile",
  teacher: "Staff Profile",
  assignment: "Assignment Management",
  material: "Study Materials",
  leave: "Leave Management",
  subject: "Subject Management",
  class: "Classes",
  attendance: "Attendance Management",
  timetable: "Timetable Management",
  schedule: "Schedule Management",
  lecture_swap: "Lecture Swap",
  edit_lecture: "Edit Lecture",
  lecture_conversion: "Convert Lecture",
  department: "Department Management",
  institute: "Institute Management",
  admin: "User Management",
  user: "User Management",
  permission: "Permission Settings",
  role: "Role Settings",
  rbac: "RBAC",
  gfm: "Guardian Faculty",
  support: "Contact Support",
  chat: "Messages",
  message: "Messages",
  messages: "Messages",
  academic: "Academic Info",
  report: "Reports & Analytics",
  analytics: "Analytics",
  exam: "Exam Management",
  hall_ticket: "Hall Ticket",
  audit: "Audit Logs",
  notification: "Notifications",
  dashboard: "Dashboard",
  course: "Course Management",
  promotion: "Student Promotion",
  faq: "Help and Support",
  special_session: "Special Sessions",
  registration: "Registration",
  documents: "Documents",
  pii: "Personal Information",
  meeting: "Meetings",
};

export function formatModuleDisplayName(module, opts = {}) {
  const { appendManagement = true } = opts;
  const slug = String(module || "").trim().toLowerCase();
  if (!slug) return "Module";

  if (MODULE_DISPLAY_NAMES[slug]) {
    const label = MODULE_DISPLAY_NAMES[slug];
    if (!appendManagement || /\bmanagement\b/i.test(label)) return label;
    return `${label} Management`;
  }

  const words = slug.split(/[._\s-]+/).filter(Boolean);
  const titled = words
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(" ");

  if (!titled) return "Module";
  if (/\bmanagement\b/i.test(titled)) return titled;
  if (!appendManagement) return titled;
  return `${titled} Management`;
}

export default formatModuleDisplayName;
